// Language Selector Handler
document.addEventListener('DOMContentLoaded', function() {
  const languageLinks = document.querySelectorAll('.nav-link-icon[href*="locale="]');
  
  languageLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      const localeMatch = href.match(/locale=([a-z]{2})/);
      
      if (localeMatch) {
        const locale = localeMatch[1];
        // Set the locale cookie and redirect
        document.cookie = `shopify.language=${locale};path=/`;
        // Redirect to the same page with the locale parameter
        window.location.href = href;
      }
    });
  });
});
